import React, { useState, useEffect } from 'react';
import { Input, Button, Dropdown, Menu as AntMenu, Table, Grid, Modal, Tooltip, message } from 'antd';
import { EyeOutlined, StopOutlined } from '@ant-design/icons';

import { useNavigate } from 'react-router-dom';
import Menu from '../../components/Menu/Menu';
import './Lists.scss';
import Header from '../../components/Header/Header';
import { listService } from "../../services/ListService";
import { useLocation } from 'react-router-dom';
import ListStatusGuard from './ListStatusGuard';

const { Search } = Input;
const VerticalDotsIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ cursor: 'pointer' }}
    >
        <circle cx="12" cy="5" r="2" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="12" cy="19" r="2" />
    </svg>
);


const ManualProcessing = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [lists, setLists] = useState([]);
    const pathToKey = {
        '/liste-necesar': 'creeaza',
        '/gata-de-trimis': 'gata',
        '/liste-in-ofertare': 'ofertare',
        '/liste-ofertate': 'ofertate',
        '/procesare-manuala': 'procesareManuala',
        '/liste-arhivate': 'arhivate',

    };
    const selectedMenuKey = pathToKey[location.pathname];
    const [counts, setCounts] = useState({});

    useEffect(() => {

        listService.getCounts()
            .then(res => {
                if (res.data) {
                    setCounts(res.data.list_counts);

                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });

    }, []);
    useEffect(() => {
        handleSearch('');



        listService.getLists('manual_processing')
            .then(res => {
                if (res.data) {
                    setLists(res.data.necessity_lists);
                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });
    }, []);

    const handleSearch = (value) => {
        setSearchQuery(value);
        if (value.length > 0) {
            listService.searchList(value, 1, 'manual_processing')
                .then(res => {
                    if (res.data?.necessity_lists) {
                        setSearchResults(res.data.necessity_lists);
                    } else {
                        setSearchResults([]);
                    }
                })
                .catch(err => {
                    console.error("Eroare la căutare:", err);
                    setSearchResults([]);
                });
        } else {
            setSearchResults([]);
        }
    };




    const archiveList = (record) => {
        if (!ListStatusGuard.canArchive(record.status, record)) {
            return;
        }

        Modal.confirm({
            title: 'Arhivezi această listă?',
            okText: 'Arhivează',
            cancelText: 'Anulează',
            okButtonProps: { danger: true },
            onOk: () =>
                listService.archiveList(record.id).then((res) => {
                    const successMessage = res?.data?.message || 'Lista a fost arhivată cu succes.';
                    message.success(successMessage);
                    setLists(prev => prev.filter(l => l.id !== record.id));
                })
        });
    };

    const getArchiveDisabledReason = (record) => {
        if (record.status !== 'manual_processing') {
            return 'Arhivarea este disponibilă doar în etapa de procesare manuală.';
        }

        const canArchiveFlag =
            record?.manual_processing_counts?.can_archive ??
            record?.can_archive;
        if (canArchiveFlag !== undefined && !Boolean(canArchiveFlag)) {
            return 'Arhivarea este disponibilă doar după ce backend-ul confirmă că lista poate fi arhivată.';
        }

        const allSupplierListsBlocked =
            record?.manual_processing_counts?.all_supplier_lists_blocked ??
            record?.all_supplier_lists_blocked ??
            record?.allSupplierListsBlocked;

        if (allSupplierListsBlocked === undefined) {
            return 'Nu se poate valida arhivarea: lipsește indicatorul de blocare a listelor.';
        }

        if (!Boolean(allSupplierListsBlocked)) {
            return 'Arhivarea este disponibilă doar după blocarea tuturor listelor per furnizor, inclusiv lista neatribuită.';
        }

        return '';
    };

    const renderActions = (_, record) => {
        const canOpenManualProcessing = record.status === 'manual_processing';
        const canArchiveList = ListStatusGuard.canArchive(record.status, record);
        const archiveDisabledReason = canArchiveList ? '' : getArchiveDisabledReason(record);

        const menu = (
            <AntMenu
                onClick={({ key }) => handleMenuClick(key, record)}
                items={[
                    {
                        key: 'vezi',
                        label: 'Vezi atribuirile',
                        icon: <EyeOutlined />,
                        disabled: !canOpenManualProcessing,
                    },
                    {
                        key: 'archive',
                        label: canArchiveList ? (
                            'Arhivează lista'
                        ) : (
                            <Tooltip title={archiveDisabledReason} placement="left">
                                <span>Arhivează lista</span>
                            </Tooltip>
                        ),
                        icon: <StopOutlined />,
                        danger: true,
                        disabled: !canArchiveList,
                    }
                ]}
            />
        );

        return (
            <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
                <Button icon={<VerticalDotsIcon />} />
            </Dropdown>
        );
    };

    const listColumns = [
        {
            title: 'Număr listă',
            dataIndex: 'id',
            key: 'id',
            width: 100,
        },
        {
            title: 'Nume',
            dataIndex: 'title',
            key: 'title'

        },
        {
            title: 'Atribuite',
            key: 'assigned',
            render: (_, record) =>
                record.manual_processing_counts?.assigned ?? 0,
        },
        {
            title: 'Neatribuite',
            key: 'unassigned',
            render: (_, record) =>
                record.manual_processing_counts?.unassigned ?? 0,
        },



        {
            title: 'Acțiuni',
            key: 'actions',
            width: 100,
            render: renderActions,
        }
    ];

    const handleMenuClick = (key, record) => {
        if (key === 'vezi') {
            if (record.status !== 'manual_processing') {
                return;
            }

            navigate(`/vezi-atribuiri/${record.id}`);
        }

        if (key === 'archive') {
            archiveList(record);
        }
    };

    const MobileList = () => {
        const dataSource = searchQuery ? searchResults : lists;

        if (dataSource.length === 0) {
            return (
                <div className="list__empty-state">
                    <p className="list__empty-state-text">Nicio listă găsită.</p>
                </div>
            );
        }

        return (
            <div className="list__mobile-table-wrapper">
                <div className="list__mobile-table-header">
                    <div className="list__mobile-table-header-cell" style={{ width: '60px', flexShrink: 0 }}>
                        Nr
                    </div>
                    <div className="list__mobile-table-header-cell list__mobile-table-header-name">
                        Nume
                    </div>
                    <div className="list__mobile-table-header-cell" style={{ width: '90px', flexShrink: 0 }}>
                        Atrib.
                    </div>
                    <div className="list__mobile-table-header-cell" style={{ width: '100px', flexShrink: 0 }}>
                        Neatr.
                    </div>
                    <div className="list__mobile-table-header-cell list__mobile-table-header-actions" style={{ width: '60px', flexShrink: 0 }}>
                        Opt
                    </div>
                </div>

                <div className="list__mobile-list">
                    {dataSource.map((row) => (
                        <div key={row.id} className="list__mobile-card">
                            <div className="list__mobile-card-cell" style={{ width: '60px', flexShrink: 0 }}>
                                {row.id}
                            </div>
                            <div className="list__mobile-card-cell list__mobile-card-name" title={row.title}>
                                {row.title}
                            </div>
                            <div className="list__mobile-card-cell" style={{ width: '90px', flexShrink: 0, textAlign: 'center' }}>
                                {row.manual_processing_counts?.assigned ?? 0}
                            </div>
                            <div className="list__mobile-card-cell" style={{ width: '100px', flexShrink: 0, textAlign: 'center' }}>
                                {row.manual_processing_counts?.unassigned ?? 0}
                            </div>
                            <div className="list__mobile-card-cell list__mobile-card-actions" style={{ width: '60px', flexShrink: 0 }}>
                                {renderActions(null, row)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className='standard products list'>
            <Header />


            <div className='standard__container list'>
                <Menu />
                <div className='standard__wrapper'>
                    <div style={{ padding: 24, minHeight: 280 }}>
                        <h2 className='standard__page-title'>Procesare manuala</h2>
                        <h4 className='standard__page-info'>
                            Gestionare manuala a listelor ofertate si ne-ofertate.
                        </h4>

                        <div className='list__search-box'>
                            <Search
                                className="list__search-input"
                                placeholder="Caută lista..."
                                onChange={(e) => handleSearch(e.target.value)}
                                value={searchQuery}
                                enterButton
                                allowClear
                            />

                        </div>
                        <div className='list__tabs-wrapper'>
                            <AntMenu
                                mode="horizontal"
                                selectedKeys={[selectedMenuKey]}
                                style={{ marginTop: 16 }}
                                onClick={(e) => {
                                    switch (e.key) {
                                        case 'creeaza':
                                            navigate('/liste-necesar');
                                            break;
                                        case 'gata':
                                            navigate('/gata-de-trimis');
                                            break;
                                        case 'ofertare':
                                            navigate('/liste-in-ofertare');
                                            break;
                                        case 'ofertate':
                                            navigate('/liste-ofertate');
                                            break;
                                        case 'procesareManuala':
                                            navigate('/procesare-manuala');
                                            break;
                                        case 'arhivate':
                                            navigate('/liste-arhivate');
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                            >
                                <AntMenu.Item key="creeaza">Creează listă</AntMenu.Item>
                                <AntMenu.Item key="gata">
                                    Gata de trimis ({counts.ready_to_send || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="ofertare">
                                    Liste în ofertare ({counts.offering || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="ofertate">
                                    Liste ofertate ({counts.offered || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="procesareManuala">
                                    Procesare manuala ({counts.manual_processing || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="arhivate">
                                    Liste arhivate ({counts.archived || 0})
                                </AntMenu.Item>
                            </AntMenu>
                        </div>


                        <div className="list__table-wrapper">

                            <div className='list__table-content'>
                                {!isMobile ? (
                                    <Table
                                        dataSource={searchQuery ? searchResults : lists}
                                        columns={listColumns}
                                        rowKey="id"
                                        pagination={false}
                                        scroll={{ x: true }}
                                    />
                                ) : (
                                    <MobileList />
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
    );
};

export default ManualProcessing;